import { IconComponent } from 'models/icons';

/**
 * This file was auto-generated using svgr
 *
 * Source file: assets/icons/webar.svg
 */
const IconWebar: IconComponent = ({
  size = 24,
  color = '#E2E2E2',
  className,
  svgElementProps: props = {},
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    color={color}
    className={className}
    {...props}
  >
    <path
      d="M7.832 5.384v13.23c0 .125.023.248.066.362a.962.962 0 00.183.306c.079.087.17.156.272.203a.75.75 0 00.32.07h6.653c.11 0 .22-.024.32-.07a.833.833 0 00.272-.203.962.962 0 00.183-.306c.042-.115.065-.237.066-.362V5.384c-.001-.124-.024-.247-.066-.362a.96.96 0 00-.183-.305.834.834 0 00-.271-.203.751.751 0 00-.32-.07H8.672a.787.787 0 00-.59.273 1.016 1.016 0 00-.251.667zm-.83 0c.001-.501.178-.981.491-1.334.314-.354.738-.551 1.18-.55h6.653c.22-.001.437.047.64.141.202.094.386.233.542.408.155.175.279.383.363.612.085.229.128.475.129.723v13.23a2.025 2.025 0 01-.492 1.336 1.576 1.576 0 01-1.181.55H8.672a1.573 1.573 0 01-1.18-.55 2.025 2.025 0 01-.492-1.336V5.384z"
      fill="currentColor"
    />
    <path
      d="M12 18.61c.461 0 .834-.423.834-.945 0-.521-.373-.944-.833-.944-.46 0-.833.423-.833.944 0 .522.373.944.833.944z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.416 14.833h7.501c.11 0 .216.05.294.138a.506.506 0 01.122.334.506.506 0 01-.122.334.392.392 0 01-.294.138h-7.5a.392.392 0 01-.295-.138.505.505 0 01-.122-.334c0-.125.044-.245.122-.334a.392.392 0 01.294-.138z"
      fill="currentColor"
    />
  </svg>
);

export default IconWebar;
